import { useContext, useState } from "react";
import AuthContext from "../store/authContext";
import AXIOS from "../components/helpers/axios"
import axios from "axios";

function useApi() {
    const authCtx = useContext(AuthContext);

    const BASE_URL = process.env.REACT_APP_API_URL;
    const FORM_HEADERS = JSON.parse(process.env.REACT_APP_API_HEADERS_FORM)
    const HEADERS = JSON.parse(process.env.REACT_APP_API_HEADERS);
    const LOGIN_HEADERS = JSON.parse(process.env.REACT_APP_API_HEADERS_FORM)


    if (authCtx.token !== undefined) {
        FORM_HEADERS["Authorization"] = `Bearer ${authCtx.token}`;
        HEADERS["Authorization"] = `Bearer ${authCtx.token}`;
    }

    const [data, setData] = useState(null);
    const [apiStatus, setAPIStatus] = useState({
        isLoading: false,
        isLoaded: false,
        error: null,
    });

    const fetchData = async (url, params, base_url) => {
        if (params === undefined) {
            params = null;
        }

        if (base_url === undefined) {
            base_url = BASE_URL
        }

        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));

        try {
            // Construct URL with query parameters
            const queryParams = new URLSearchParams(params).toString();
            const URL = `${base_url}${url}${params ? `?${queryParams}` : ""}`;

            // const headers = HEADERS;

            const response = await fetch(URL, {
                method: "GET",
                headers: HEADERS,
            });

            const data = await response.json();

            if (data.error) {
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: data,
                }));
            } else {
                setData(data);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            }
        } catch (error) {
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: false,
                isLoaded: true,
                error: error,
            }));
        }
    };

    const login = async (url, body) => {

        // if (base_url === undefined) {
        //     base_url = BASE_URL
        // }

        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));
        setData(null);



        try {
            const res = await AXIOS.post(url, body, {
                headers: LOGIN_HEADERS,
            });
            if (res.data) {
                setData(res.data);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            } else {
                setData(null);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: res?.message ?? '',
                }));
            }
        } catch (error) {

            setData(null);
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: false,
                isLoaded: true,
                error: error?.response?.data?.error ?? 'An Error occured',
            }));
        }
    };

    const postData = async (url, body, base_url) => {
        if (base_url === undefined) {
            base_url = BASE_URL
        }

        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));
        setData(null);

        try {
            const formData = new FormData();

            Object.keys(body).forEach((key) => {
                formData.append(key, body[key]);
            });

            const response = await axios.post(`${base_url}${url}`, formData, {
                headers: FORM_HEADERS,
            });
            const data = response?.data;
            if (data.status === false) {
                setData(null);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: data.data.error,
                }));
            } else {
                setData(data?.data);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            }
        } catch (error) {
            setData(null);
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: false,
                isLoaded: true,
                error: error?.response?.data?.error,
            }));
        }
    };
    const postRawJSONData = async (url, body, base_url) => {
        if (base_url === undefined) {
            base_url = BASE_URL
        }

        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));
        setData(null);

        try {
            // const formData = new FormData();

            // Object.keys(body).forEach((key) => {
            //     formData.append(key, body[key]);
            // });

            const response = await axios.post(`${base_url}${url}`, body, {
                headers: HEADERS,
            });
            const data = response?.data;
            if (data.status === false) {
                setData(null);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: data.data.error,
                }));
            } else {
                setData(data?.data);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            }
        } catch (error) {
            setData(null);
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: false,
                isLoaded: true,
                error: error?.response?.data?.error,
            }));
        }
    };

    const patchRawJSONData = async (url, body, base_url) => {
        if (base_url === undefined) {
            base_url = BASE_URL
        }

        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));
        setData(null);

        try {
            const response = await axios.patch(`${base_url}${url}`, body, {
                headers: HEADERS,
            });
            const data = response?.data;
            if (data.status === false) {
                setData(null);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: data.data.error,
                }));
            } else {
                setData(data?.data);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.error || error?.response?.data?.data || 'An Error Occurred';


            setData(null);
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: false,
                isLoaded: true,
                error: errorMessage,
            }));

            throw new Error(errorMessage)
        }
    };

    const putData = async (base_url, url, body) => {
        if (base_url === undefined) {
            base_url = BASE_URL
        }

        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));
        setData(null);

        try {
            const URL = `${base_url}${url}`;

            const headers = HEADERS;

            const response = await fetch(URL, {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(body),
            });

            const data = await response.json();

            if (data.error) {
                setData(null);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: data,
                }));
            } else {
                setData("success");
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            }
        } catch (error) {
            setData(null);
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: false,
                isLoaded: true,
                error: error,
            }));
        }
    };

    const deleteData = async (url, body, base_url,) => {
        if (base_url === undefined) {
            base_url = BASE_URL
        }

        setData(null);
        setAPIStatus((prevStatus) => ({
            ...prevStatus,
            isLoading: true,
            isLoaded: false,
            error: null,
        }));
        try {
            const URL = `${base_url}${url}`;

            const headers = HEADERS;

            const response = await fetch(URL, {
                method: "DELETE",
                headers: headers,
                body: JSON.stringify(body),
            });

            const data = await response.json();

            if (data.error) {
                setData(null);
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: true,
                    isLoaded: false,
                    error: data,
                }));
            } else {
                setData("success");
                setAPIStatus((prevStatus) => ({
                    ...prevStatus,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                }));
            }
        } catch (error) {
            setData(null);
            setAPIStatus((prevStatus) => ({
                ...prevStatus,
                isLoading: true,
                isLoaded: false,
                error: error,
            }));
        }
    };

    return {
        data,
        apiStatus,
        fetchData,
        login,
        postData,
        postRawJSONData,
        patchRawJSONData,
        putData,
        deleteData,
    };
}

export default useApi;